import { FormattedMessage } from 'react-intl';
import React from 'react';
export function EmptyTableRow(props) {
    return React.createElement("tr", null,
        React.createElement("td", { className: "align-middle py-4 text-center text-muted", colSpan: props.colSpan },
            React.createElement(FormattedMessage, { id: "no.results" })));
}
export function EmptyDivRow(props) {
    return React.createElement("div", null,
        React.createElement("div", { className: "align-middle py-4 text-center text-muted" },
            React.createElement(FormattedMessage, { id: "no.results" })));
}
